import { useAsyncValue, useNavigation } from "react-router-dom";

import DataTable from "@/components/data-table";
import ItemsPerPageSelector from "@/components/data-table/items-per-page-selector";
import { HStack, VStack } from "@/components/layout";
import { isLoading } from "@/utils/react-router-fetcher";
import LOCATION_TABLE_COLUMNS from "./columns";

export default function LocationTable() {
  const transactions = useAsyncValue();
  const { state } = useNavigation();

  return (
    <VStack className="mt-10 w-full gap-5">
      <HStack className="w-full items-center justify-between">
        <p className="text-lg font-medium">Transaction data</p>
        <ItemsPerPageSelector label="Transactions per page" />
      </HStack>
      <div className="w-full overflow-x-auto">
        <DataTable
          data={transactions.items}
          columns={LOCATION_TABLE_COLUMNS}
          totalItems={transactions.metadata.count}
          initialSort="date_DESC"
          isLoading={isLoading(state)}
        />
      </div>
    </VStack>
  );
}
